$(function () {
    $('.jsTeamOperationalCare').owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      navText:[
        '<svg class="icon-chevron-left text-secondary mx-1 my-2"><use xlink:href="#icon-chevron-left"></use></svg>',
        '<svg class="icon-chevron-right text-secondary mx-1 my-2"><use xlink:href="#icon-chevron-right"></use></svg>'
      ],
      dots: false,
      items: 3,
      responsive:{
        0:{
            items:1
        },
        576:{
            items:2
        },
        1000:{
            items:3
        }
      }
    });
})
  